import store from '../store';
import axios from "axios";
import router from '../router';

const trackTopsort = {
    trackCluviBase(){
        let data_track = {
            view_vue: router.app._route.name,
        }
        
        data_track.table_code = store.getters['ontable/tableId']
        data_track.front_lang = store.getters['shared/lang']
        data_track.session_id = store.getters['profile/session_id']
        data_track.service = store.getters['order/service']
        data_track.customer_id = store.getters['customer/instance_id']
        data_track.supplier_id = store.getters['customer/supplier_id']
        data_track.profile_id = store.getters['profile/profile_id']
        data_track.acquisition_id = store.getters['shared/acquisition_id']
        return data_track
    },
    trackBannerClick(banner) {
        // let data_cluvi = this.trackCluviBase()
        // data_cluvi.event = event;
        // axios({
        //     method: "post",
        //     url: `${process.env.VUE_APP_API_CLUVIMKT}/api/trackings.json`,
        //     data: data_track
        // })
        let dataEventToSort = {
            clicks: [{
                resolvedBidId: banner.topsortWinner.resolvedBidId,
                occurredAt: this.getRFC3339Date(),
                opaqueUserId: store.getters['profile/session_id'],
                id: `${store.getters['shared/acquisition_id']}_${this.generateUUIDv4()}`
            }
        ]}
        
        this.sendEventToTopsort(dataEventToSort);
    },
    trackBannerView(banner){
        // let data_cluvi = this.trackCluviBase()
        // data_cluvi.event = event;
        // axios({
        //     method: "post",
        //     url: `${process.env.VUE_APP_API_CLUVIMKT}/api/trackings.json`,
        //     data: data_track
        // })
        let dataEventToSort = {
            impressions: [{
                resolvedBidId: banner.topsortWinner.resolvedBidId,
                occurredAt: this.getRFC3339Date(),
                opaqueUserId: store.getters['profile/session_id'],
                id: `${store.getters['shared/acquisition_id']}_${this.generateUUIDv4()}`
            }
        ]}
        
        this.sendEventToTopsort(dataEventToSort);
    },
    sendEventToTopsort(dataEventToSort){
        axios({
            method: "post",
            url: `https://api.topsort.com/v2/events`,
            headers: {
                Authorization: `Bearer ${process.env.VUE_APP_TOPSORT_APIKEY}`
            },
            data: dataEventToSort
        })
        .then(response => {
            (response)
        })
        .catch(error => {
            (error)
        });
    },
    trackProductView(product){
        //data_cluvi = this.trackCluviBase()
        //data_cluvi.event = event;
        // axios({
        //     method: "post",
        //     url: `${process.env.VUE_APP_API_CLUVIMKT}/api/trackings.json`,
        //     data: data_track
        // })
        let dataEventToSort = {
            impressions: [{
                resolvedBidId: product.topsortWinner.resolvedBidId,
                occurredAt: this.getRFC3339Date(),
                opaqueUserId: store.getters['profile/session_id'],
                id: `${store.getters['shared/acquisition_id']}_${this.generateUUIDv4()}`
            }
        ]}
        
        this.sendEventToTopsort(dataEventToSort);
    },
    trackProductClick(product){
        //data_cluvi = this.trackCluviBase()
        //data_cluvi.event = event;
        // axios({
        //     method: "post",
        //     url: `${process.env.VUE_APP_API_CLUVIMKT}/api/trackings.json`,
        //     data: data_track
        // })
        let dataEventToSort = {
            clicks: [{
                resolvedBidId: product.topsortWinner.resolvedBidId,
                occurredAt: this.getRFC3339Date(),
                opaqueUserId: store.getters['profile/session_id'],
                id: `${store.getters['shared/acquisition_id']}_${this.generateUUIDv4()}`
            }
        ]}
        
        this.sendEventToTopsort(dataEventToSort);

        let unitPrice = Math.round(product.price*0.43);
        if(unitPrice <= 10) unitPrice = 5600;

        let dataEventToSortPurchase = {
            purchases: [{
                items: [{
                    quantity: 1,
                    productId: product.topsortWinner.id,
                    unitPrice: unitPrice
                }],
                resolvedBidId: product.topsortWinner.resolvedBidId,
                occurredAt: this.getRFC3339Date(),
                opaqueUserId: store.getters['profile/session_id'],
                id: `${store.getters['shared/acquisition_id']}_${this.generateUUIDv4()}`
            }
        ]}
        this.sendEventToTopsort(dataEventToSortPurchase);

    },
    getRFC3339Date() {
        const now = new Date();
        const year = now.getUTCFullYear();
        const month = String(now.getUTCMonth() + 1).padStart(2, '0');
        const day = String(now.getUTCDate()).padStart(2, '0');
        const hours = String(now.getUTCHours()).padStart(2, '0');
        const minutes = String(now.getUTCMinutes()).padStart(2, '0');
        const seconds = String(now.getUTCSeconds()).padStart(2, '0');
        const milliseconds = String(now.getUTCMilliseconds()).padStart(3, '0');
        
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
    },
    generateUUIDv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}

export {
    trackTopsort
}
